import * as types from './mutation-types'


export const createProduct = ({ commit, dispatch, state }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post('store/product', data).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const createProductVariations = ({ commit, dispatch, state }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post('store/product/variations', data).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const findProductById = ({ commit, dispatch, state }, id) => {
    return new Promise((resolve, reject) => {
        window.axios.get(`product/${id}/details`).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}


// data.dry_run : aperçu (rien n'est enregistré) ; data.silent : erreurs affichées par l'écran
export const importProducts = ({ commit, dispatch, state }, data) => {
    let formData = new FormData();
    formData.append('file', data.file);
    formData.append('_method', 'POST');
    formData.append('dry_run', data.dry_run ? '1' : '0');
    return new Promise((resolve, reject) => {
        window.axios.post(`import/products`, formData, {headers: {'Content-type': 'multipart/form-data'}, silent: !!data.silent}).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const exportProduct = ({ commit, dispatch, state }) => {
    return new Promise((resolve, reject) => {
        window.axios.get('export/products', { responseType: 'blob' }).then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data], { type: response.headers['content-type'] }));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'products.xlsx');
            document.body.appendChild(link);
            link.click();
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}




export const deleteProduct = ({ commit, dispatch, state }, id) => {
    return new Promise((resolve, reject) => {
        window.axios.delete(`product/${id}/delete`).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const verifyIfProductCanDeleted = ({ commit, dispatch, state }, id) => {
    return new Promise((resolve, reject) => {
        window.axios.delete(`product/verify/${id}/delete`).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const deleteProductSaleElement = ({ commit, dispatch, state }, {productSaleElement, productId}) => {
    return new Promise((resolve, reject) => {
        window.axios.delete(`/productSaleElement/${productSaleElement}/product/${productId}/delete`).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const updateProductSaleElements = ({ commit, dispatch, state }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post(`/productSaleElements/update`, data).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const deleteProductSaleElements = ({ commit, dispatch, state }, {data, productId}) => {
    return new Promise((resolve, reject) => {
        window.axios.delete(`/productSaleElements/product/${productId}/delete`, {params: {productSaleElements: data}}).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const loadProductSale = ({ commit, dispatch, state }, id) => {
    return new Promise((resolve, reject) => {
        window.axios.get('get/productSaleElements/'+id+'/collection').then((response) => {
            commit(types.ADD_STORE_PRODUCT_SALE_ELEMENTS, {
                id: id,
                product_sale_elements: response.data.product_sale_element
            })
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const loadAllProductSale = ({ commit, dispatch, state }) => {
    return new Promise((resolve, reject) => {
        window.axios.get('get/all/productSaleElements/collection').then((response) => {
            commit(types.LOAD_PRODUCT_SALE_ELEMENTS, response.data)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const loadAllProductSaleByCategories = ({ commit, dispatch, state }) => {
    return new Promise((resolve, reject) => {
        window.axios.get('/get/productSaleElements/groupBy/category').then((response) => {
            commit(types.LOAD_PRODUCT_SALE_ELEMENTS_BY_CATEGORIES, response.data)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const getInitialisationStoreProduct = ({ commit, dispatch, state }, id) => {
    return new Promise((resolve, reject) => {
        window.axios.get('get/stores/'+id+'/products').then((response) => {
            commit(types.ADD_STORE_PRODUCT_SALE_ELEMENTS, {
                id: id,
                product_sale_elements: response.data.product_sale_element
            })
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const loadProductSaleStore = ({ commit, dispatch, state }, id) => {
    return new Promise((resolve, reject) => {
        window.axios.get('load/productSaleElements/'+id+'/store').then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const loadProductSaleShop = ({ commit, dispatch, state }, id) => {
    return new Promise((resolve, reject) => {
        window.axios.get('load/productSaleElements/'+id+'/shop').then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}


export const removeProductStore = ({commit, dispatch, state}, data) => {
    return new Promise((resolve, eject) => {
        window.axios.delete(`store/${data.id}/product/${data.product_sale_element_id}/delete`).then((response) => {
            resolve(response)
        }).catch((err) => {
            eject(err)
        })
    })
}

export const addProductStore = ({commit, dispatch, state}, data) => {
    return new Promise((resolve, eject) => {
        window.axios.post('add/products/'+ data.id +'/store', data).then((response) => {
            resolve(response)
        }).catch((err) => {
            eject(err)
        })
    })
}

export const updateProductStore = ({commit, dispatch, state}, data) => {
    return new Promise((resolve, eject) => {
        window.axios.patch('update/product/'+data.id+'/store', data).then((response) => {
            resolve(response)
        }).catch((err) => {
            eject(err)
        })
    })
}


export const uploadImage = ({ commit, dispatch, state }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post('product/upload-avatar', data).then((response) => {
            commit(types.SET_IMAGE, { id: response.data.id, image: response.data.image })

            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const uploadProductMultiImage = ({ commit, dispatch, state }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post('product/upload/multi/images', data).then((response) => {
            commit(types.SET_MULTI_IMAGE, { id: response.data.id, images: response.data.images })
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}


export const deleteProductImage = ({commit, dispatch, state},  {product, image}) => {
    let route = `/delete/${product}/product/${image}/image`
    return new Promise((resolve, reject) => {
        window.axios.delete(route).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const loadAllProducts = ({ commit }) => {
    return new Promise((resolve, reject) => {
        window.axios.get('get/products/collection').then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}
export const storeProductSaleElementsLots = ({ commit, dispatch, state }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post(`/store/productSaleElements/lots`, data).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}
export const deleteProductLot = ({ commit, dispatch, state }, id) => {
    return new Promise((resolve, reject) => {
        window.axios.delete(`productSaleElement/lot/${id}/delete`).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}
export const updateLotBarcode = ({commit, dispatch, state}, data) => {
    return new Promise((resolve, eject) => {
        window.axios.patch('update/productSaleElement/lot/'+data.id+'/barcode', data).then((response) => {
            resolve(response)
        }).catch((err) => {
            eject(err)
        })
    })
}

export const getProductSaleElementLot = ({commit, dispatch, state}, id) => {
    return new Promise((resolve, eject) => {
        window.axios.get('get/productSaleElement/'+ id +'/lot').then((response) => {
            resolve(response)
        }).catch((err) => {
            eject(err)
        })
    })
}

export const listProductLots = ({commit, dispatch, state}) => {
    return new Promise((resolve, eject) => {
        window.axios.get('get/productSaleElement/lots').then((response) => {
            commit(types.SET_PRODUCT_LOTS, response.data)
            resolve(response)
        }).catch((err) => {
            eject(err)
        })
    })
}



export const generateBarcode = ({ commit, dispatch, state }, id) => {
    return new Promise((resolve, reject) => {
        window.axios.get(`product-sale-element/${id}/barcode/generate`).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const downloadBarcodePDF = ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post('product-sale-elements/barcodes/pdf', data, { responseType: 'blob' }).then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', 'etiquettes-barcodes.pdf')
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const updateProductStatus = ({ commit, dispatch, state }, {id}) => {
    return new Promise((resolve, reject) => {
        window.axios.patch('product/' + id + '/set/online').then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const setCategoryProductsOnline = ({ commit }, { categoryId, online }) => {
    return new Promise((resolve, reject) => {
        window.axios.patch('category/' + categoryId + '/products/set/online', { online }).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const  downloadProductImportTemplate = ({ commit }) => {
    return new Promise((resolve, reject) => {
        // Utilisation d'axios pour récupérer le fichier
        window.axios({
            url: 'download/import/model', // ton endpoint Laravel
            method: 'GET',
            responseType: 'blob', // important pour les fichiers
        })
            .then((response) => {
                // Créer un lien pour télécharger le fichier
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'modele-import-articles.xlsx'); // nom du fichier
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                resolve(response);
            })
            .catch((error) => {
                reject(error);
            });
    });
}

export const downloadProductModel = ({ commit, dispatch, state }) => {
    return new Promise((resolve, reject) => {
        window.axios.get('download-product-model', { responseType: 'blob' }).then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data], { type: response.headers['content-type'] }));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'model-product.xlsx');
            document.body.appendChild(link);
            link.click();
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const generateProductDescription = ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post('ai/generate-description', data).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}